<template>
  <dashboard-shipments-state
    :count="loaded ? $n(count) : '-'"
    :title="$tc(`dashboard.titles.shipments.in_progress`, !loaded ? 0 : count)"
    state="in_progress"
    class="dashboard-shipments-state-in-progress"
  />
</template>

<script>
  import { defineComponent } from '@vue/composition-api'

  import DashboardShipmentsState from './../DashboardShipmentsState/index.vue'

  /**
   * @module component - DashboardShipmentsStateInProgress
   * @param {boolean} loaded
   * @param {number} count
   */
  export default defineComponent({
    name: 'DashboardShipmentsStateInProgress',
    props: {
      loaded: {
        type: Boolean,
        default: false
      },
      count: {
        type: Number,
        default: null
      }
    },
    components: {
      DashboardShipmentsState
    }
  })
</script>
